// extracted by mini-css-extract-plugin
export default {"listItem":"_-_-record-it-components-src-dropdown-DropdownListItem-__listItem"};